import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "./Navigation";
import Home from "./Home";
import ProductList from "./ProductList";
import Product from "./Product";
import CartList from "./CartList";
import Footer from "./Footer";
import Finished from "./Finished";
import PageContact from "./PageContact";
import PageChanges from "./PageChanges";
import PageHowToBuy from "./PageHowToBuy";
import PageHowToPay from "./PageHowPay";
import PageSends from "./PageSends";
import TrackingSale from "./TrackingSale";
import Login from "./Login";
import MyOrders from "./MyOrders";
import Checkout from "./Checkout";
import useTenant from "../tenant/useTenant";

const Routera = () => {
  const tenant = useTenant();

  return (
    <BrowserRouter>
      <Navigation />
      <div id="container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/contact" element={<PageContact />} />
          <Route path="/changes" element={<PageChanges />} />
          <Route path="/howtobuy" element={<PageHowToBuy />} />
          <Route path="/howtopay" element={<PageHowToPay />} />
          <Route path="/sends" element={<PageSends />} />
          <Route path="/product-type/:productTypeId/:sizeId" element={<ProductList />} />
          <Route path="/product-type/:productTypeId" element={<ProductList />} />
          <Route path="/product/:productId" element={<Product />} />
          <Route path="/cart" element={<CartList />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/finished" element={<Finished />} />
          <Route path="/tracking-sale/:saleId/:clientId" element={<TrackingSale />} />
          {tenant.features.hasMyOrders && (
            <>
              <Route path="/my-orders" element={<MyOrders />} />
              <Route path="/my-orders/:cell_phone/:client_id" element={<MyOrders />} />
            </>
          )}
        </Routes>
      </div>
      <Footer />
    </BrowserRouter>
  );
}

export default Routera;
